@if (recentlyViewedItems$ | async; as recentlyViewedItems) {
  @if (recentlyViewedItems.length > 0) {
    <div class="flex items-center mb-4">
      <h2 class="font-bold text-black mr-4 md:text-lg">{{ 'recentlyViewed.title' | transloco }}</h2>
      <button class="text-blue-interact hover:underline cursor-pointer" (click)="clearAll()">Clear all</button>
    </div>

    <app-slider
      [items]="(recentlyViewedItems$ | async)!"
      [itemTemplate]="machineTemplate">
    </app-slider>

    <ng-template #machineTemplate [templateType]="recentlyViewedItemTemplateType" let-machine>
      <a
        class="flex flex-shrink-0 gap-4 items-center bg-white p-2 rounded-md last:mr-8"
        draggable="false"
        [routerLink]="['/machine', machine.id]"
      >
        <img class="max-w-12 max-h-10" [src]=machine.thumbnail.public_asset_url alt="" draggable="false"/>
        <h3 class="mr-3 text-sm text-black whitespace-nowrap">
          {{ machine.title }}
        </h3>
      </a>
    </ng-template>

  }
}
